import Dropdown from 'app/components/forms/base_dropdown/component'
import { nullValidator, withValidation } from 'app/components/forms/util'

const DropdownGeneric = withValidation(Dropdown, nullValidator)

export default DropdownGeneric
